import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PaymentStatus } from '@shared/services/gql.service';
import { Utils } from '@shared/utils/utils';

import { InvoicesGridFormatterService } from './invoices-grid-formatter.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    <div class="flex items-center whitespace-nowrap">
      <div class="mr-1 h-3 w-3 rounded-full" [ngClass]="bgClass"></div>
      <div class="mr-1" [ngClass]="textClass">{{ status }}</div>
    </div>
  `,
})
export class PaymentStatusComponent implements ICellRendererAngularComp {
  bgClass!: string;
  params!: ICellRendererParams;
  status!: string;
  textClass!: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const status: PaymentStatus | string = params.data?.payment_status || params.value || '';

    if (params.node?.rowPinned) {
      this.textClass = '';
      this.status = Utils.zeroHyphen;

      return;
    }

    const { bgClass, label, textClass } =
      InvoicesGridFormatterService.getInvoicePaymentStatusStyles(status);

    this.bgClass = bgClass;
    this.status = label;
    this.textClass = textClass;
  }

  refresh(): boolean {
    return false;
  }
}
